import './exanteAlert.css';

const ExanteAlert = ({ available }) => {

  const getAlert = (available) => available ?
    (
      <div className={`exante_alert_box ${available <= Number(process.env.REACT_APP_EXANTE_ALERT_THRESHOLD) ? 'un' : ''}sufficient_amount`} >
        <div >
          <div className='exante_alert_box_text'>
            <span>Argent disponible sur le compte trades Exante : {available} €</span>
          </div>
        </div>
      </div>
    )
    :
    (
      <div className={`exante_alert_box unsufficient_amount`} >
        <div >
          <div className='exante_alert_box_text'>
            <span>L'argent disponible n'a pas pu être récupéré sur Exante</span>
          </div>
        </div>
      </div>)


  return getAlert(available)

}

export default ExanteAlert